export default __webpack_public_path__ + "static/media/img-01.e71c5858.jpg";